import { useNavigate } from "react-router-dom";
import ReportingSemiCircleChartCard from "./ReportingSemiCircleChartCard";
import SectionTitle from "../SectionTitle";
import { appPaths } from "../../Routes";

type ReportingScopeSectionProps = {
    notMaterialEmissionsSourcesCount: number;
    omittedEmissionsSourcesCount: number;
    estimatedEmissionsSourcesCount: number;
    measuredSecondaryEmissionsSourcesCount: number;
    measuredPrimaryEmissionsSourcesCount: number;
};

const ReportingScopeSection = ({
    notMaterialEmissionsSourcesCount,
    omittedEmissionsSourcesCount,
    estimatedEmissionsSourcesCount,
    measuredSecondaryEmissionsSourcesCount,
    measuredPrimaryEmissionsSourcesCount,
}: ReportingScopeSectionProps) => {
    const navigate = useNavigate();

    const materialityReportingChartData = [
        {
            name: "Material",
            value:
                omittedEmissionsSourcesCount +
                estimatedEmissionsSourcesCount +
                measuredSecondaryEmissionsSourcesCount +
                measuredPrimaryEmissionsSourcesCount,
            color: "#369A8A",
            queryParam: "material",
        },
        {
            name: "Not Material",
            value: notMaterialEmissionsSourcesCount,
            color: "#19424B",
            queryParam: "not-material",
        },
    ];

    const consumptionDataStatusChartData = [
        {
            name: "Measured - Primary",
            value: measuredPrimaryEmissionsSourcesCount,
            color: "#8EB85B",
            queryParam: 4,
        },
        {
            name: "Measured - Secondary",
            value: measuredSecondaryEmissionsSourcesCount,
            color: "#F3EE70",
            queryParam: 3,
        },
        {
            name: "Estimated",
            value: estimatedEmissionsSourcesCount,
            color: "#FAAC73",
            queryParam: 2,
        },
        {
            name: "Omitted",
            value: omittedEmissionsSourcesCount,
            color: "#BA1A1A",
            queryParam: 1,
        },
    ];

    return (
        <>
            <SectionTitle title="Reporting Scope" noSeperator />
            <div className="flex flex-col gap-6 lg:grid lg:grid-cols-2">
                <ReportingSemiCircleChartCard
                    title="Materiality"
                    data={materialityReportingChartData}
                    onSectorClick={(data) =>
                        navigate(
                            `${appPaths.emissionsSources()}?selectedTab=${
                                data.queryParam
                            }`
                        )
                    }
                />
                <ReportingSemiCircleChartCard
                    title="Consumption Data Status"
                    data={consumptionDataStatusChartData}
                    onSectorClick={(data) =>
                        navigate(
                            `${appPaths.emissionsSources()}?dataStatusEs=${
                                data.queryParam
                            }`
                        )
                    }
                />
            </div>
        </>
    );
};

export default ReportingScopeSection;
